import Vue from 'vue';
import Router from 'vue-router';
import Principal from '@/components/Main.vue';
import { storeInstance } from '@/store';
import * as AuthService from '@/services/AuthService.js';
import * as RolService from '@/services/RolService.js';

Vue.use(Router);

let routesArray = [
  {
    path: '/',
    redirect: { name: 'catalogo' },
    name: 'Default',
    component: Principal,
    children: [
      {
        path: '/misServiciosDigitales',
        name: 'serviciosDigitales',
        component: () => import('@/components/ServiciosDigitales/views/Informacion.vue'),
        meta: {
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Mis Servicios Digitales', link: '/serviciosDigitales' }
          ]
        },
        props: true
      },
      {
        path: '/usuarios',
        name: 'usuarios',
        component: () => import('@/components/Usuarios/views/Listado.vue'),
        meta: {
          availableRoles: ['admin', 'superadmin'],
          adminEntidad: true,
          userDelivery: true,
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Usuarios externos' }
          ]
        },
        props: true
      },
      {
        path: '/usuarios/editar/:idUser?',
        name: 'form_user_edit',
        component: () => import('@/components/Usuarios/views/Listado.vue'),
        meta: {
          availableRoles: ['admin', 'superadmin'],
          adminEntidad: true,
          userDelivery: true,
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Usuarios externos' }
          ]
        },
        props: true
      },
      {
        path: '/servicios',
        name: 'servicios',
        component: () => import('@/components/Servicios/views/Listado.vue'),
        meta: {
          availableRoles: ['superadmin'],
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Servicios Digitales' }
          ]
        }
      },
      {
        path: '/aplicaciones',
        name: 'aplicaciones',
        component: () => import('@/components/Aplicaciones/views/Listado.vue'),
        meta: {
          availableRoles: ['admin', 'superadmin'],
          access: true,
          userDelivery: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Aplicaciones' }
          ]
        }
      },
      {
        path: '/tematicas',
        name: 'tematicas',
        component: () => import('@/components/Tematicas/views/Listado.vue'),
        meta: {
          availableRoles: ['superadmin'],
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Tematicas' }
          ]
        }
      },
      {
        path: '/tematicas/editar/:idTematica?',
        name: 'form_tematica',
        component: () => import('@/components/Tematicas/views/Edicion.vue'),
        meta: {
          availableRoles: ['superadmin'],
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Tematicas', link: '/tematicas' },
            { name: 'Edición de Tematica' }
          ]
        }
      },
      {
        path: '/tematicas/nuevo',
        name: 'form_new_tematica',
        component: () => import('@/components/Tematicas/views/Edicion.vue'),
        meta: {
          availableRoles: ['superadmin'],
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Tematicas', link: '/tematicas' },
            { name: 'Nueva Tematica' }
          ]
        }
      },
      {
        path: '/ambitos',
        name: 'ambitos',
        component: () => import('@/components/Ambitos/views/Listado.vue'),
        meta: {
          availableRoles: ['superadmin'],
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Ámbitos' }
          ]
        }
      },
      {
        path: '/ambitos/editar/:idAmbito?',
        name: 'form_ambito',
        component: () => import('@/components/Ambitos/views/Edicion.vue'),
        meta: {
          availableRoles: ['superadmin'],
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Ámbitos', link: '/ambitos' },
            { name: 'Edición de Ámbito' }
          ]
        }
      },
      {
        path: 'ambitos/nuevo',
        name: 'form_new_ambito',
        component: () => import('@/components/Ambitos/views/Edicion.vue'),
        meta: {
          availableRoles: ['superadmin'],
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Ámbitos', link: '/ambitos' },
            { name: 'Nuevo Ámbito' }
          ]
        }
      },
      {
        path: '/catalogo',
        name: 'catalogo',
        component: () => import('@/components/Catalogo/views/Catalogo.vue'),
        meta: {
          access: true,
          admin: false
        }
      },
      {
        path: '/servicios/editar/:idServ',
        name: 'form_service',
        component: () =>
          import('@/components/Servicios/views/Informacion.vue'),
        meta: {
          availableRoles: ['superadmin'],
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Servicios Digitales', link: '/servicios' },
            { name: 'Edición de Servicio Digital' }
          ]
        }
      },
      {
        path: 'servicios/nuevo',
        name: 'form_new_serv',
        component: () =>
          import('@/components/Servicios/views/Informacion.vue'),
        meta: {
          availableRoles: ['superadmin'],
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Servicios Digitales', link: '/servicios' },
            { name: 'Nuevo Servicio Digital' }
          ]
        }
      },
      {
        path: '/aplicaciones/editar/:idApp',
        name: 'form_application',
        component: () =>
          import('@/components/Aplicaciones/views/Informacion.vue'),
        meta: {
          availableRoles: ['admin', 'superadmin'],
          userDelivery: true,
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Aplicaciones', link: '/aplicaciones' },
            { name: 'Edición de Aplicación' }
          ]
        }
      },
      {
        path: 'aplicaciones/nuevo',
        name: 'form_new_app',
        component: () =>
          import('@/components/Aplicaciones/views/Informacion.vue'),
        meta: {
          availableRoles: ['superadmin'],
          userDelivery: true,
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Aplicaciones', link: '/aplicaciones' },
            { name: 'Nueva Aplicación' }
          ]
        }
      },
      {
        path: '/verticales',
        name: 'verticales',
        component: () => import('@/components/Verticales/views/Listado.vue'),
        meta: {
          availableRoles: ['superadmin'],
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Verticales' }
          ]
        }
      },
      {
        path: 'verticales/nuevo',
        name: 'form_new_vertical',
        component: () =>
          import('@/components/Verticales/views/Informacion.vue'),
        meta: {
          availableRoles: ['superadmin'],
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Verticales', link: '/verticales' },
            { name: 'Nuevo Vertical' }
          ]
        }
      },
      {
        path: 'verticales/editar/:idVertical',
        name: 'form_edit_vertical',
        component: () =>
          import('@/components/Verticales/views/Informacion.vue'),
        meta: {
          availableRoles: ['superadmin'],
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Verticales', link: '/verticales' },
            { name: 'Edición de Vertical' }
          ]
        }
      },
      {
        path: '/exportacion',
        name: 'exportacion',
        component: () => import('@/components/Exportacion/views/ExportacionDatos.vue'),
        meta: {
          availableRoles: ['admin', 'superadmin'],
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Exportación de datos' }
          ]
        }
      },
      {
        path: '/entidades/nuevo',
        name: 'form_new_entidad',
        component: () => import('@/components/Entidades/views/Informacion.vue'),
        meta: {
          availableRoles: ['superadmin'],
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Entidades', link: '/entidades' },
            { name: 'Nueva Entidad' }
          ]
        },
        props: true
      },
      {
        path: '/entidades',
        name: 'entidades',
        component: () => import('@/components/Entidades/views/Listado.vue'),
        meta: {
          availableRoles: ['superadmin'],
          adminEntidad: true,
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de entidades' }
          ]
        },
        props: true
      },
      {
        path: '/entidades/editar/:idEntidad',
        name: 'form_edit_entidad',
        component: () => import('@/components/Entidades/views/Informacion.vue'),
        meta: {
          availableRoles: ['superadmin'],
          adminEntidad: true,
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Entidades', link: '/entidades' },
            { name: 'Editar Entidad' }
          ]
        },
        props: true
      },
      {
        path: '/autorizaciones',
        name: 'autorizaciones',
        component: () => import('@/components/Autorizaciones/views/Listado.vue'),
        meta: {
          availableRoles: ['admin', 'superadmin'],
          adminEntidad: true,
          userDelivery: true,
          access: true,
          admin: true,
          breadcrumb: [
            { name: 'Gestion de Autorizaciones' }
          ]
        },
        props: true
      }
    ]
  },
  {
    path: '/RegistroExterno',
    name: 'RegistroExterno',
    component: () => import('@/components/Usuarios/views/Registro_Externo.vue'),
    meta: {
      AllowAnonymous: true
    }
  },
  {
    path: '/Validacion',
    name: 'validacion',
    component: () => import('@/components/Usuarios/views/Validacion.vue'),
    meta: {
      AllowAnonymous: true
    }
  },
  {
    path: '/RememberPassword',
    name: 'recordarpassword',
    component: () => import('@/components/Usuarios/views/RecordarPassword.vue'),
    meta: {
      AllowAnonymous: true
    }
  },
  {
    path: '/checkmail',
    name: 'passwordemail',
    component: () => import('@/components/Usuarios/views/PasswordEmail.vue'),
    meta: {
      AllowAnonymous: true
    }
  },
  {
    path: '/checkpassword',
    name: 'passwordinternal',
    component: () => import('@/components/Usuarios/views/PasswordInternal.vue'),
    meta: {
      AllowAnonymous: true
    }
  },
  {
    path: '/Recover',
    name: 'recordar',
    component: () => import('@/components/Usuarios/views/Resetear.vue'),
    meta: {
      AllowAnonymous: true
    }
  },
  {
    path: '*',
    name: '404',
    component: () => import('@/shared/error-pages/components/404.vue'),
    meta: {
      isErrorPage: true,
      access: true,
      admin: false
    }
  },
  {
    path: '/401',
    name: '401',
    component: () => import('@/shared/error-pages/components/401.vue'),
    meta: {
      isErrorPage: true,
      access: true,
      admin: false
    }
  }
];

const routes = new Router({
  base: process.env.VUE_APP_URL,
  mode: 'history',
  routes: routesArray,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});
routes.beforeEach(async (to, from, next) => {
  await storeInstance.restored;
  const { access, adminEntidad, userDelivery, availableRoles, isErrorPage } = to.meta;
  // Página anonima no comprobamos nada
  if (to.matched.some(record => record.meta.AllowAnonymous)) {
    next();
  } else {
    // Página que necesita login autorización (User)
    if (access) {
      // ¿No está autorizado? Login
      if (!AuthService.authenticated()) {
        // Hacemos login
        AuthService.login();
      } else {
        // Se ha conseguido autorizar en la aplicacion
        if (!await AuthService.isTokenValid()) return AuthService.logout();
        await AuthService.setData();
        if (isErrorPage) return next();
        if (!storeInstance.getters['PF/isAuthIn']) { return next('401'); }
        // Comprobamos que el usuario tenga rol access y sea externo
        if (!storeInstance.getters['PF/haveAccess'] && storeInstance.getters['PF/isExternal']) return next('401');
        // ¿La página necesita algún rol?
        if (availableRoles !== undefined && availableRoles.length > 0) {
          const user = storeInstance.state.PF.user;
          const haveRole = RolService.checkIfExistRole(user, availableRoles);

          if (adminEntidad || userDelivery) {
            const isDeliveryUser = storeInstance.getters['PF/isDeliveryUser'];
            const isAdminEntidad = storeInstance.getters['PF/isAdminEntidad'];

            if (!isDeliveryUser && !isAdminEntidad && !haveRole) return next('401');
          }
          if (!haveRole && !adminEntidad && !userDelivery) return next('401');
        }

        let isSuperAdmin = storeInstance.getters['PF/isSuperAdmin'];
        let isExternal = storeInstance.getters['PF/isExternal'];

        if (isExternal) {
          if (isSuperAdmin) {
            await RolService.getEntidadesVisibles();
          }

          if (to.name === 'catalogo' && from.name === null) {
            await RolService.getEntidadesVisiblesRelated();
            var haveVisibleEntitiesLikeSuperAdmin = storeInstance.getters['PF/haveEntidadesVisibles'];
            var haveVisibleEntitiesLikeUserOrAdmin = storeInstance.getters['PF/haveEntidadesVisiblesRelated'];

            if ((haveVisibleEntitiesLikeSuperAdmin && isSuperAdmin) || haveVisibleEntitiesLikeUserOrAdmin) {
              next('/misServiciosDigitales');
            }
          }
        }
        return next();
      }
    } else {
      // Página privada que no necesita autorización (Admin)
      next();
    }
  }
});

export default routes;
